
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useToast } from '@/hooks/use-toast'
import { supabase } from '../utils/supabaseClient'

const Index = () => {
  const navigate = useNavigate()
  const { toast } = useToast()

  useEffect(() => {
    // Check if user is authenticated and redirect accordingly
    const checkSession = async () => {
      try {
        const { data: { session } } = await supabase.auth.getSession()
        
        if (session) {
          console.log('User session found:', session.user.id)
          
          // Check if this user was supposed to be an operator (from metadata)
          const isOperator = session.user.user_metadata?.is_operator
          const schoolId = session.user.user_metadata?.school_id
          const firstName = session.user.user_metadata?.first_name
          const lastName = session.user.user_metadata?.last_name
          
          if (isOperator && schoolId) {
            console.log('User has operator metadata, checking if operator profile exists')
            
            // Check if operator profile exists
            const { data: operator, error: operatorError } = await supabase
              .from('operators')
              .select('*')
              .eq('user_id', session.user.id)
              .single()
            
            if (operatorError && operatorError.code === 'PGRST116') {
              // No operator profile found, create it
              console.log('Creating missing operator profile for confirmed user')
              
              const { data: newOperator, error: createError } = await supabase
                .from('operators')
                .insert({
                  user_id: session.user.id,
                  school_id: schoolId,
                  email: session.user.email,
                  first_name: firstName,
                  last_name: lastName,
                })
                .select()
                .single()
              
              if (createError) {
                console.error('Failed to create operator profile:', createError)
                toast({
                  title: "Profile creation failed",
                  description: "Failed to complete operator account setup. Please contact support.",
                  variant: "destructive",
                })
                await supabase.auth.signOut()
                navigate('/login')
              } else {
                console.log('Operator profile created successfully:', newOperator)
                toast({
                  title: "Account activated!",
                  description: "Your operator account has been successfully activated.",
                })
                navigate('/operator/dashboard')
              }
            } else if (operator) {
              // Operator profile exists, redirect to operator dashboard
              navigate('/operator/dashboard')
            } else {
              // Some other error occurred
              console.error('Error checking operator profile:', operatorError)
              navigate('/dashboard')
            }
          } else {
            // Regular user, redirect to dashboard
            navigate('/dashboard')
          }
        } else {
          // No session, redirect to login
          navigate('/login')
        }
      } catch (error) {
        console.error('Session check error:', error)
        navigate('/login')
      }
    }
    
    checkSession()
  }, [navigate, toast])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600"></div>
    </div>
  )
}

export default Index
